import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add OPD Service
function createOPDService(params: any) {
    const baseUrl = `/services/addServiceInfo`;
    return api.create(`${baseUrl}`, params);
}
// update OPD Service
function updateOPDService(params: any) {
    const baseUrl = '/services/updServiceInfo';
    return api.update(`${baseUrl}`, params);
}

// get all OPD Service
function getAllOPDService(params: any) {
    const baseUrl = '/services/getServiceInfo';
    return api.create(`${baseUrl}`, params);
}

// get all OPD Service
function getOPDService(params: any) {
    const baseUrl = '/services/getServiceInfo';
    return api.create(`${baseUrl}`, params);
}

// get all service dropdown
function getServicesDropdown(params: any) {
    const baseUrl = '/services/getServiceList';
    return api.create(`${baseUrl}`, params);
}

// delete OPD Service
function deleteOPDService(params: any) {
    const baseUrl = '/services/delServiceInfo';
    return api.create(`${baseUrl}`, params);
}

export { createOPDService, updateOPDService, getOPDService, getAllOPDService, deleteOPDService, getServicesDropdown };
